import axios from 'axios'
import { authHeader } from '../_helpers'

const baseURL = process.env.VUE_APP_API_URL

export default () => {
  return axios.create({
    baseURL: baseURL,
    headers: authHeader()
  })
}
